import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

import { useManufacturer } from "../../../../../hooks/query";

export default function useCreateManufacturer() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { useCreate } = useManufacturer();
    const createManufacturerSvc = useCreate();

    const handleCreateManufacturer = async (values: any) => {
        try {
            const manufacturerParams = {
                Name: values.Name,
                ShortName: values.ShortName,
                Headquarters: values.Headquarters || undefined,
                Founded: values.Founded || undefined,
                Industry: values.Industry || undefined,
                Website: values.Website || undefined,
                Status: values.Status || "Active",
            };

            await createManufacturerSvc.mutateAsync(manufacturerParams);

            queryClient.invalidateQueries({ queryKey: ["manufacturers"] });

            // Navigate back to manufacturers list
            navigate("/admin/manufacture/list");
        } catch (error) {
            console.error("Error creating manufacturer:", error);
            throw error;
        }
    };

    return {
        handleCreateManufacturer,
        createManufacturerSvc,
    };
}
